export default __webpack_public_path__ + "static/media/Text-field-(1).fc10e1c7.png";